"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplashBlockShortcut = void 0;
var react_1 = __importDefault(require("react"));
var ColorUtils_1 = require("@CommonFrontendBackend/StyleServiceV2/ColorUtils");
var WithColorFilterSubscription_1 = __importDefault(require("DreamCoat/WithColorFilterSubscription/WithColorFilterSubscription"));
var commonBlockOptions_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/commonBlockOptions");
var splashConfig_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/splashConfig");
var StyleShortCutContainer_1 = __importDefault(require("Common/AtomicUI/StyleShortCutContainer/StyleShortCutContainer"));
var CommonBlockStyleShortcut_1 = __importDefault(require("../CommonBlockStyleShortcut/CommonBlockStyleShortcut"));
var CommonTextShortcut_1 = __importDefault(require("../CommonTextShortcut/CommonTextShortcut"));
var MotionShortcut_1 = __importDefault(require("../MotionShortcut/MotionShortcut"));
var CssEditor_1 = __importDefault(require("../CssEditor/CssEditor"));
var ColorUtils_2 = require("Common/Utils/ColorUtils/ColorUtils");
var mobx_react_1 = require("mobx-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var Types_1 = require("DataStores/Account/Types");
var ColorPalette_1 = __importDefault(require("Common/ColorPalette/ColorPalette"));
var GetBlockStyle_1 = require("@CommonFrontendBackend/StyleServiceV2/GetBlockStyle");
var SplashBlockShortcut = (function (_super) {
    __extends(SplashBlockShortcut, _super);
    function SplashBlockShortcut() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.defaultTintOpacity = 25;
        _this.whiteTintValue = "#ffffff";
        _this.shortcutChangedText = "Block Styles Shortcuts Changed";
        _this.renderBlockTab = function () {
            var _a = _this.props, openBrandSetup = _a.openBrandSetup, brandStore = _a.brandStore, telemetry = _a.telemetry, blockStore = _a.blockStore;
            var blockStyleStore = blockStore.blockStyleStore;
            var _b = blockStyleStore.model, backgroundCard = _b.backgroundCard, tintBlendMode = _b.tintBlendMode, background = _b.background;
            return (react_1.default.createElement(kaleidoscope_1.TabPanel, null,
                react_1.default.createElement("div", { className: "style-shortcut__main" },
                    react_1.default.createElement(CommonBlockStyleShortcut_1.default, { openBrandSetup: openBrandSetup, handleBackgroundChange: _this.handleBackgroundColorChange, blockWidthOptions: commonBlockOptions_1.blockWidthOptions, blockSpacingOptions: splashConfig_1.splashBlockSpacingOptions, colorSectionTitle: "tint color", brandStore: brandStore, telemetry: telemetry, blockStore: blockStore },
                        _this.shouldDisplayFillTypeOptions() && (react_1.default.createElement("div", { className: "style-shortcut__section style-shortcut__fill-type-section" },
                            react_1.default.createElement("div", { className: "style-shortcut__buttons-container" },
                                react_1.default.createElement(kaleidoscope_1.SegmentedControl, { label: "Blend mode", labelHidden: true, options: splashConfig_1.tintBlendModeOptions, selectedValue: tintBlendMode, onClickHandler: _this.handleFillTypeChange })))),
                        react_1.default.createElement("div", { className: "style-shortcut__section" },
                            react_1.default.createElement(kaleidoscope_1.SliderInput, { handleValueChange: _this.handleOverlayColorOpacityChange, label: "opacity", unit: "%", initialInputValue: _this.convertToInputOpacity(background.opacity) }))),
                    react_1.default.createElement("div", { className: "style-shortcut__section label" },
                        react_1.default.createElement(kaleidoscope_1.Toggle, { label: "background card", value: backgroundCard.on, onChange: _this.toggleIncludeBackgroundCard }),
                        backgroundCard.on && (react_1.default.createElement("div", { className: "style-shortcut__buttons-container" },
                            react_1.default.createElement(ColorPalette_1.default, { presetColors: brandStore.colorsWithThemeIndex, onColorChange: _this.handleBackgroundCardColorChange, selectedColor: (0, GetBlockStyle_1.sanitizeColor)((0, GetBlockStyle_1.convertColorObjToColor)(backgroundCard.color), brandStore.colorsWithThemeIndex), theme: "light", type: "block" })))),
                    backgroundCard.on && (react_1.default.createElement("div", { className: "style-shortcut__splash-background-section" },
                        react_1.default.createElement("div", { className: "style-shortcut__section" },
                            react_1.default.createElement(kaleidoscope_1.SliderInput, { handleValueChange: _this.handleBackgroundCardColorOpacityChange, label: "opacity", unit: "%", initialInputValue: _this.convertToInputOpacity(backgroundCard.color.opacity) })))))));
        };
        _this.renderTextTab = function () {
            var _a = _this.props, filteredColors = _a.filteredColors, telemetry = _a.telemetry, blockStore = _a.blockStore;
            return (react_1.default.createElement(kaleidoscope_1.TabPanel, null,
                react_1.default.createElement("div", { className: "style-shortcut__main" },
                    react_1.default.createElement(CommonTextShortcut_1.default, { colors: filteredColors, telemetry: telemetry, blockStore: blockStore }))));
        };
        _this.renderMotionTab = function () {
            var _a = _this.props, telemetry = _a.telemetry, blockStore = _a.blockStore;
            return (react_1.default.createElement(kaleidoscope_1.TabPanel, null,
                react_1.default.createElement("div", { className: "style-shortcut__main" },
                    react_1.default.createElement(MotionShortcut_1.default, { blockStore: blockStore, telemetry: telemetry }))));
        };
        _this.renderCssEditor = function () {
            var blockStore = _this.props.blockStore;
            var blockStyleStore = blockStore.blockStyleStore;
            return (react_1.default.createElement(kaleidoscope_1.TabPanel, null,
                react_1.default.createElement("div", { className: "style-shortcut__main" },
                    react_1.default.createElement(CssEditor_1.default, { blockStyleStore: blockStyleStore }))));
        };
        _this.track = function (name, parameters) {
            _this.props.telemetry.track(name, parameters || {}, {
                blockIntercom: true,
            });
        };
        _this.convertToOpacity = function (inputValue) {
            return Number(inputValue) / 100;
        };
        _this.handleOverlayColorOpacityChange = function (opacityInputValue) {
            var blockStyleStore = _this.props.blockStore.blockStyleStore;
            var newBackground = __assign({}, blockStyleStore.model.background);
            newBackground.opacity = _this.convertToOpacity(opacityInputValue);
            blockStyleStore.setStylePropsByKey("background", newBackground);
            _this.track(_this.shortcutChangedText, {
                block_styles_shortcuts_opacity: opacityInputValue,
            });
        };
        _this.handleBackgroundCardColorOpacityChange = function (opacityInputValue) {
            var blockStyleStore = _this.props.blockStore.blockStyleStore;
            var opacity = _this.convertToOpacity(opacityInputValue);
            var newBackgroundCard = __assign({}, blockStyleStore.model.backgroundCard);
            newBackgroundCard.color.opacity = opacity;
            newBackgroundCard.color.abs = (0, ColorUtils_1.replaceOpacity)(newBackgroundCard.color.abs, opacity);
            blockStyleStore.setStylePropsByKey("backgroundCard", newBackgroundCard);
            _this.track(_this.shortcutChangedText, {
                block_styles_shortcuts_background_card_opacity: opacityInputValue,
            });
        };
        _this.handleBackgroundColorChange = function (color) {
            var handleBackgroundChange = _this.props.handleBackgroundChange;
            _this.updateTintBlendModeWhenTintColorChange();
            if (handleBackgroundChange) {
                handleBackgroundChange(color);
            }
        };
        _this.updateTintBlendModeWhenTintColorChange = function () {
            var blockStyleStore = _this.props.blockStore.blockStyleStore;
            if ((0, ColorUtils_1.areColorsEquivalent)(blockStyleStore.model.background.abs, _this.whiteTintValue)) {
                var normalMode = "normal";
                blockStyleStore.setStylePropsByKey("tintBlendMode", normalMode);
            }
        };
        _this.handleFillTypeChange = function (tintBlendModeLabel) {
            var blockStyleStore = _this.props.blockStore.blockStyleStore;
            blockStyleStore.setStylePropsByKey("tintBlendMode", tintBlendModeLabel);
            _this.track(_this.shortcutChangedText, {
                block_styles_shortcuts_tint_type: tintBlendModeLabel === "normal" ? "normal" : "blend",
            });
        };
        _this.shouldDisplayFillTypeOptions = function () {
            var blockStyleStore = _this.props.blockStore.blockStyleStore;
            return !splashConfig_1.tintBlendModeExclusionColors.includes(blockStyleStore.model.background.abs);
        };
        _this.toggleIncludeBackgroundCard = function () {
            var blockStyleStore = _this.props.blockStore.blockStyleStore;
            var newBackgroundCard = __assign({}, blockStyleStore.model.backgroundCard);
            newBackgroundCard.on = !newBackgroundCard.on;
            blockStyleStore.setStylePropsByKey("backgroundCard", newBackgroundCard);
            _this.track(_this.shortcutChangedText, {
                block_styles_shortcuts_background_card: newBackgroundCard.on,
            });
        };
        _this.handleBackgroundCardColorChange = function (color) {
            var _a = _this.props, blockStyleStore = _a.blockStore.blockStyleStore, handleBackgroundChange = _a.handleBackgroundChange;
            var newBackgroundCard = __assign({}, blockStyleStore.model.backgroundCard);
            newBackgroundCard.color.abs = (0, ColorUtils_1.replaceOpacity)(color.value, newBackgroundCard.color.opacity);
            newBackgroundCard.color.themeIndex = color.themeIndex;
            blockStyleStore.setStylePropsByKey("backgroundCard", newBackgroundCard);
            if (handleBackgroundChange) {
                handleBackgroundChange(color);
            }
            _this.track(_this.shortcutChangedText, {
                block_styles_shortcuts_background_card_color: (0, ColorUtils_2.getTelemetryColor)(color),
            });
        };
        _this.convertToInputOpacity = function (cssOpacity) {
            if (cssOpacity === 0) {
                return 0;
            }
            if (!cssOpacity) {
                return _this.defaultTintOpacity;
            }
            return Math.round(Number(cssOpacity) * 100);
        };
        return _this;
    }
    SplashBlockShortcut.prototype.componentDidMount = function () {
        this.track("Block Styles Shortcuts Viewed");
    };
    SplashBlockShortcut.prototype.render = function () {
        var _a = this.props, stylePermissionStore = _a.stylePermissionStore, blockStore = _a.blockStore;
        var blockStyleStore = blockStore.blockStyleStore;
        var withBlockStyle = stylePermissionStore.allowStyle(Types_1.StyleAccessType.Block);
        var withTextStyle = stylePermissionStore.allowStyle(Types_1.StyleAccessType.Text);
        var withMotion = stylePermissionStore.allowStyle(Types_1.StyleAccessType.Motion);
        var withCssEditor = stylePermissionStore.shouldHaveCssEditor(blockStyleStore.model.css && blockStyleStore.model.css.length);
        return (react_1.default.createElement(StyleShortCutContainer_1.default, { lowPadding: true },
            react_1.default.createElement(kaleidoscope_1.Tabs, null,
                react_1.default.createElement(kaleidoscope_1.TabList, { isBordered: true, "aria-label": "Style options", align: kaleidoscope_1.TabListAlign.Center },
                    withBlockStyle && react_1.default.createElement(kaleidoscope_1.Tab, null, "Block"),
                    withTextStyle && react_1.default.createElement(kaleidoscope_1.Tab, null, "Text"),
                    withMotion && react_1.default.createElement(kaleidoscope_1.Tab, null, "Animate"),
                    withCssEditor && react_1.default.createElement(kaleidoscope_1.Tab, null, "CSS")),
                react_1.default.createElement(kaleidoscope_1.TabPanels, { transitionHeight: true },
                    withBlockStyle && this.renderBlockTab(),
                    withTextStyle && this.renderTextTab(),
                    withMotion && this.renderMotionTab(),
                    withCssEditor && this.renderCssEditor()))));
    };
    SplashBlockShortcut = __decorate([
        mobx_react_1.observer
    ], SplashBlockShortcut);
    return SplashBlockShortcut;
}(react_1.default.Component));
exports.SplashBlockShortcut = SplashBlockShortcut;
exports.default = (0, WithColorFilterSubscription_1.default)(SplashBlockShortcut);
